import { func, shape, string } from 'prop-types'
import React from 'react'

const Tile = props => (
  <div className="tile">
    <a href={props.url} onClick={props.onClick}>
      {props.image !== null &&
        <div
          className="image"
          style={{ backgroundImage: `url(${props.image})` }}
        />
      }
      {props.image === null &&
        <div className="image" />
      }
      <div className="site-building">{props.siteBuilding}</div>
      <div className="name">{props.name}</div>
    </a>
  </div>
)
Tile.defaultProps = {
  image: null,
}
Tile.propTypes = {
  image: string,
  name: string.isRequired,
  onClick: func.isRequired,
  siteBuilding: string.isRequired,
  url: string.isRequired,
}

export default Tile
